import Slider from "./Slider";
import Rail from "./Rail";
import Control from "./Control";

export * from "./Slider";
export * from "./Rail";
export * from "./Control";

export default class SliderInstance extends Slider {
    static Rail = Rail;
    static Control = Control;
}


// WEBPACK FOOTER //
// ./src/Components/Slider/index.tsx